import React from "react";

export default function InfoIcon({ size = 50, color = "#ffffff", ...props }) {
	return <span className="infoIcon" {...props} style={{
		fontSize: 0,
		display: "inline-block",
		height: size,
		width: size
	}}>
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="square" strokeLinejoin="arcs" > <circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg >
	</span>
}